import React, { useState } from "react";
import {
    Button,
    Grid,
    Hidden,
    InputLabel,
    makeStyles,
} from "@material-ui/core";
import { MdOutlinePreview } from "react-icons/md";
import { CustomCheckbox } from "../../ccmode2.0/CcmodeSetupNew/FormFields";
import CustomColorPicker from "../../ccmode2.0/CcmodeSetupNew/FormFields/CustomColorPicker";
import { ImagePreview } from "../../Popup/ImagePreview";

const useStyles = makeStyles((theme) => ({
    textField: {
        "& .MuiOutlinedInput-root": {
            borderRadius: "4px !important",
        },
        "& .MuiInputBase-input.Mui-disabled": {
            borderRadius: "4px",
            height: "0px",
        },
    },
    previewBtn: {
        height: "40px",
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
    },
    checkBoxContrainer: {
        display: "flex",
        justifyContent: "space-between",
        [theme.breakpoints.up("xs")]: {
            alignItems: "center",
        },
    },
}));

export default function ThemeForm(props) {
    const classes = useStyles();
    const {
        formField: {
            wl_primarycolor,
            n_fontcolor,
            lab_primary,
            lab_fontcolor,
            theme,
            show_custom_detail_page,
        },
        values,
        setFieldValue,
        feedsetting,
    } = props;

    const theme_data = [
        {
            value: "theme1",
            label: "Theme 1",
        },
        {
            value: "theme2",
            label: "Theme 2",
        },
        {
            value: "theme3",
            label: "Theme 3",
        },
    ];

    const allowedThemes = feedsetting?.allowed_themes
        ? feedsetting.allowed_themes.split(",").map((el) => ({
              value: el,
              label: el,
          }))
        : theme_data;

    const [preview, showPreview] = useState(false);

    const HandlePreview = () => {
        if (values.theme && values.theme.length) {
            showPreview(true);
        }
    };

    return (
        <React.Fragment>
            <ImagePreview
                show={preview}
                image={values.theme}
                onClose={() => showPreview(false)}
                responseOnOk={() => showPreview(false)}
            />
            <Grid container spacing={3}>
                <Grid item xs={12} className="my-6">
                    <Grid container spacing={3} alignItems="flex-start">
                        <Grid item xs={12} md={4}>
                            <InputLabel className="font-size-h6 font-weight-bold text-capitalize">
                                Theme Selection *
                                <span className="small d-block mt-2 line-height-lg">
                                    Choose a visual theme to match your brand’s
                                    identity.
                                </span>
                            </InputLabel>
                        </Grid>
                        <Grid item xs={12} md={8}>
                            <div className={`${classes.checkBoxContrainer}`}>
                                <CustomCheckbox
                                    name={theme.name}
                                    label={theme.label}
                                    data={allowedThemes}
                                    classes={theme.classes}
                                    setFieldValue={setFieldValue}
                                    values={values}
                                    selectallfields={props.selectallfields}
                                />
                                {/* <Button
                                    className={classes.previewBtn}
                                    variant="outlined"
                                    onClick={() => HandlePreview()}
                                    disabled={
                                        values.theme && !values.theme.length
                                    }
                                >
                                    <MdOutlinePreview
                                        className="mr-3"
                                        size={18}
                                    />
                                    Preview
                                </Button> */}
                            </div>
                        </Grid>
                    </Grid>
                </Grid>
                <hr className="w-100" />
                <Grid item xs={12} className="my-6">
                    <Grid container spacing={3} alignItems="flex-start">
                        <Grid item xs={12} md={4}>
                            <InputLabel className="font-size-h6 font-weight-bold text-capitalize">
                                Customize Theme Colors
                                <span className="small d-block mt-2 line-height-lg">
                                    Set primary and secondary colors for the
                                    interface.
                                </span>
                            </InputLabel>
                        </Grid>
                        <Grid item xs={12} md={8}>
                            <Grid container spacing={3} alignItems="center">
                                <Grid
                                    item
                                    xs={12}
                                    md={3}
                                    className="text-capitalize font-weight-bold"
                                >
                                    natural
                                </Grid>
                                <Hidden mdDown>
                                    <Grid item xs={0} md={3}></Grid>
                                </Hidden>
                                <Grid item xs={6} md={3}>
                                    <CustomColorPicker
                                        name={wl_primarycolor.name}
                                        label={
                                            props.language
                                                .CCMODE_SETUP_THEME_SET_NATURAL
                                        }
                                        value={values.wl_primarycolor}
                                        setFieldValue={setFieldValue}
                                    />
                                </Grid>
                                <Grid item xs={6} md={3}>
                                    <CustomColorPicker
                                        name={n_fontcolor.name}
                                        label={
                                            props.language
                                                .CCMODE_SETUP_THEME_SET_NATURAL_FONT
                                        }
                                        value={values.n_fontcolor}
                                        setFieldValue={setFieldValue}
                                    />
                                </Grid>
                            </Grid>
                            <Grid
                                container
                                spacing={3}
                                alignItems="center"
                                className="my-6"
                            >
                                <Grid
                                    item
                                    xs={12}
                                    md={3}
                                    className="text-capitalize font-weight-bold"
                                >
                                    lab grown
                                </Grid>
                                <Hidden mdDown>
                                    <Grid item xs={0} md={3}></Grid>
                                </Hidden>
                                <Grid item xs={6} md={3}>
                                    <CustomColorPicker
                                        name={lab_primary.name}
                                        label={
                                            props.language
                                                .CCMODE_SETUP_THEME_SET_LAB
                                        }
                                        value={values.lab_primary}
                                        setFieldValue={setFieldValue}
                                    />
                                </Grid>
                                <Grid item xs={6} md={3}>
                                    <CustomColorPicker
                                        name={lab_fontcolor.name}
                                        label={
                                            props.language
                                                .CCMODE_SETUP_THEME_SET_LAB_FONT
                                        }
                                        value={values.lab_fontcolor}
                                        setFieldValue={setFieldValue}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <hr className="w-100" />
                <Grid item xs={12} className="my-6">
                    <Grid container spacing={3} alignItems="flex-start">
                        <Grid item xs={12} md={4}>
                            <InputLabel className="font-size-h6 font-weight-bold text-capitalize">
                                Display Custom Detail page
                                <span className="small d-block mt-2 line-height-lg">
                                    Display in-build diamond details page
                                    available for theme 1, theme 2 and theme 3
                                </span>
                            </InputLabel>
                        </Grid>
                        <Grid item xs={12} md={8} style={{ justifyItems: "flex-end"}}>
                            <label className="switch">
                                <input
                                    type="checkbox"
                                    className="success"
                                    defaultChecked={values.show_custom_detail_page}
                                     name={show_custom_detail_page.name}
                                    value={values.show_custom_detail_page}
                                    onClick={() => setFieldValue("show_custom_detail_page", !values.show_custom_detail_page)}
                                />
                                <span className="slider"></span>
                            </label>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </React.Fragment>
    );
}
